import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

type CtaType = 'RANKING' | 'TODAY';

/**
 * Empty 화면의 CTA 버튼 클릭 시 발화.
 * - LikedGoodsEmpty: TYPE=RANKING (찜 0건 + 필터 OFF)
 * - DeliveryFilterEmpty: TYPE=TODAY (필터 ON + 결과 0건)
 * 네이티브 `LikedProductEmptyCell` 과 동일한 형식.
 * SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogClickCtaButton = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(
    (type: CtaType) => {
      logAnalyticsEvent({
        name: 'CLICK_CTA_BUTTON',
        analytics: { TYPE: type },
      });
    },
    [logAnalyticsEvent],
  );
};
